<div class="form-template-image" [style.background]="backgroundImage"></div>
<div class="color-filter"></div>